import { render } from "./Results.vue?vue&type=template&id=024d7dd3"
import script from "./Results.vue?vue&type=script&setup=true&lang=js"
export * from "./Results.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Agencies/Results.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "024d7dd3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('024d7dd3', __exports__)) {
    api.reload('024d7dd3', __exports__)
  }
  
  module.hot.accept("./Results.vue?vue&type=template&id=024d7dd3", () => {
    api.rerender('024d7dd3', render)
  })

}


export default __exports__